import React, { useEffect } from "react";
import { connect } from "react-redux";
import { deleteUser, getUserInfo } from "../lib/session";
import { Button } from "antd";
import logo from "../assets/white-logo.svg";
import Progress from "../components/Progress";

const Profile = props => {
  const { track, history } = props;
  const { userDetails } = getUserInfo("data") || {};

  const logout = () => {
    const logoutFunc = () => {
      deleteUser();
      history.push("/");
      window.location.reload();
    };
    track("logout", "user-logout", logoutFunc, logoutFunc);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="profile">
      <div>
        <section id="header">
          <img className="header-logo" src={logo} width="90" height="90" />
        </section>
      </div>
      <div className="profile-container">
        <Button type="primary" htmlType="submit" onClick={logout}>
          Log out
        </Button>
      </div>
      <Progress userDetails={userDetails} />
    </div>
  );
};

export default connect()(Profile);
